import { Box, Spinner, Text, Tooltip, useToast } from '@chakra-ui/react';
import React, { ReactNode, useEffect, useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { BiTrash } from 'react-icons/bi';
import { IoCloseOutline } from 'react-icons/io5';
import { RiPencilLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';

import { LupaIcon } from '../../../../../assets/icons/LupaIcon';
import Dialog from '../../../../../components/Dialog';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import useTable from '../../../../../hooks/useTable';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { delay } from '../../../../../utils/delay';
import { PaginateDot } from './PaginateDot';

export const TableEquipes = () => {
  const testInfo = [];
  const isMobile = useMediaQuery('(max-width: 920px)');
  const [filterSelectState, setFilterSelectState] = useState('');
  const [filterTextState, setFilterTextState] = useState('');
  const [excluir, setExcluir] = useState({
    id: '',
    nome: '',
    status: '',
    tipo_produto: ''
  });
  const [alterar, setAlterar] = useState({
    id: '',
    nome: '',
    status: '',
    tipo_produto: ''
  });
  const [openModalExcluir, setOpenModalExcluir] = useState(false);
  const [openModalInativar, setOpenModalInativar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAlterarStatus, setLoadingAlterarStatus] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [equipesData, setEquipesData] = React.useState<any>(testInfo);
  const [originalData, setOriginalData] = React.useState<any>(testInfo);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(equipesData, page, 5);

  const toast = useToast();

  const onFilterText = (nome: string) => {
    if (
      nome?.toLowerCase().includes(filterTextState.toLowerCase()) ||
      filterTextState === '' ||
      filterTextState === null ||
      filterTextState === undefined
    ) {
      return false;
    }

    return true;
  };

  const onFilterSelect = (tipo_produto: string) => {
    if (filterSelectState === '') {
      return false;
    }
    const verify = tipo_produto === filterSelectState;

    if (verify) {
      return false;
    } else {
      return true;
    }
  };

  const handleFiltro = async () => {
    setLoading(true);
    const equipesFiltradas = originalData.filter((equipe) => {
      const validateSelect = onFilterSelect(equipe.tipo_produto);
      const validateText = onFilterText(equipe.nome);

      if (filterSelectState === '' && !validateText) {
        return equipe;
      }
      if (!validateSelect && !validateText) {
        return equipe;
      }
    });

    if (equipesFiltradas?.length === 0) {
      setNotFound(true);
      setEquipesData([]);
      setLoading(false);
      return;
    }

    setEquipesData(equipesFiltradas);
    setNotFound(false);
    setLoading(false);
  };

  const formatProduct = (product: string) => {
    let validateProduct = '';
    switch (product) {
      case 'odonto':
        validateProduct = 'Odonto';
        break;
      case 'vida':
        validateProduct = 'Vida';
        break;
      case 'saude':
        validateProduct = 'Saúde';
        break;
      case 'viagem':
        validateProduct = 'Viagem';
        break;
      default:
        validateProduct = product;
        break;
    }
    return validateProduct;
  };

  const handleFiltroSelect = async () => {
    setLoading(true);
    if (filterSelectState === '') {
      setEquipesData(originalData);
      setNotFound(false);
      setLoading(false);
      return;
    }
    const equipesFiltradas = originalData.filter((equipe) => {
      const validateSelect = onFilterSelect(equipe.tipo_produto);

      if (!validateSelect) {
        return equipe;
      }
    });

    setEquipesData(equipesFiltradas);

    if (equipesFiltradas?.length === 0) {
      setNotFound(true);
      setLoading(false);
      return;
    }
    setPage(1);
    setNotFound(false);
    setLoading(false);
  };

  const handleDeleteEquipe = async () => {
    setLoading(true);

    try {
      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/equipes/deletar/${excluir.id}`,
        {
          status: 'deleted'
        }
      );
      await getData();
      setPage(1);
      setOpenModalExcluir(false);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const handleAlterarStatusUsuario = async () => {
    setLoadingAlterarStatus(true);

    try {
      await apiSensedia.put(
        `/oportunidades-sulamerica/painel-leads/equipes/${alterar.id}`,
        {
          status: alterar.status === 'inactive' ? 'active' : 'inactive'
        }
      );

      setLoadingAlterarStatus(false);

      setEquipesData((prevEquipe) =>
        prevEquipe.map((equipe) =>
          equipe.id === alterar.id
            ? {
                ...equipe,
                status: alterar.status === 'inactive' ? 'active' : 'inactive'
              }
            : equipe
        )
      );

      setOpenModalInativar(false);
      setLoadingAlterarStatus(false);
    } catch (error: any) {
      setOpenModalInativar(false);
      setLoadingAlterarStatus(false);
    }
  };

  const getData = async () => {
    setLoading(true);

    const maxRetries = 20;
    const retryDelay = 4000;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const { data } = await apiSensedia.get(
          `/oportunidades-sulamerica/painel-leads/equipes`,
          {
            timeout: 0
          }
        );

        setOriginalData(data);
        setEquipesData(data);
        setLoading(false);
        return;
      } catch (error: any) {
        if (attempt < maxRetries) {
          await delay(retryDelay);
          continue;
        }

        setLoading(false);

        const errorObj = error?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>

              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}

                {(errorObj?.status || error?.response?.data?.statusCode) && (
                  <>{errorObj?.status ?? error?.response?.data?.statusCode}</>
                )}

                {errorObj?.status &&
                  (error?.response?.data?.message || errorObj?.message) &&
                  ' - '}

                {(error?.response?.data?.message || errorObj?.message) && (
                  <>{error?.response?.data?.message ?? errorObj?.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });

        return;
      }
    }
  };

  useEffect(() => {
    handleFiltroSelect();
  }, [filterSelectState]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="tw-w-[100%] tw-text-[#001E64]">
        <div
          className={
            isMobile
              ? 'tw-w-[100%] tw-flex tw-flex-col tw-justify-between tw-mt-[2vh] tw-mb-[3vh]'
              : 'tw-w-[100%] tw-flex tw-justify-between tw-mb-[2rem]'
          }
        >
          <div>
            <p
              className={
                isMobile
                  ? 'tw-text-[#323232] tw-font-bold tw-text-[1.25rem] tw-text-center'
                  : 'tw-text-[#323232] tw-font-bold tw-text-[1.5rem] '
              }
            >
              Acompanhamento de equipes
            </p>
            <p className={isMobile ? 'tw-text-center tw-text-[1rem]' : ''}>
              Quantidade total de equipes:{' '}
              <span className={'tw-font-bold'}>{equipesData.length}</span>
            </p>
          </div>
          <div
            className={
              isMobile
                ? 'tw-flex tw-flex-col tw-items-center'
                : 'tw-flex tw-flex-row tw-items-center'
            }
          >
            <select
              placeholder="Relação"
              onChange={(e) => {
                setFilterSelectState(e.target.value);
                setFilterTextState('');
              }}
              className={
                isMobile
                  ? 'tw-h-[2.5rem] tw-my-4 tw-px-[10px] tw-mr-[2vw] tw-w-[100%] tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-[1.85rem]'
                  : 'tw-py-[1vh] tw-px-[1vh] tw-mr-[2vw] 2xl:tw-w-[8vw] xl:tw-w-[9vw] tw-border-[#001E64] tw-border-[0.1rem] tw-rounded-[1.85rem]'
              }
            >
              <option value="">Produto</option>
              <option value="Saúde">Saúde</option>
              <option value="Vida">Vida</option>
              <option value="Odonto">Odonto</option>
              <option value="Viagem">Viagem</option>
            </select>

            <form
              className={
                isMobile
                  ? 'tw-rounded-3xl tw-flex tw-w-[100%]'
                  : 'tw-rounded-3xl tw-flex '
              }
            >
              <div
                className={
                  isMobile
                    ? 'tw-flex tw-items-center  tw-rounded-[1.85rem_0_0_1.85rem]  tw-w-[100%] tw-pl-[1vw] tw-border-[0.1rem] tw-border-r-[0] tw-border-[#001E64] '
                    : 'tw-flex tw-items-center  tw-rounded-[1.85rem_0_0_1.85rem]  xl:tw-w-[14rem] 2xl:tw-w-[14vw] tw-pl-[1vw] tw-border-[0.1rem] tw-border-r-[0] tw-border-[#001E64] '
                }
              >
                <input
                  className="tw-bg-transparent tw-w-[100%] tw-py-[1vh] tw-px-[5px]"
                  placeholder="Digite o nome da equipe"
                  value={filterTextState}
                  onChange={(e) => {
                    setFilterTextState(e.target.value);
                  }}
                />
                {filterTextState && (
                  <button
                    type={'reset'}
                    onClick={(e) => {
                      e.preventDefault();
                      setEquipesData(originalData);
                      setFilterTextState('');
                      handleFiltroSelect();
                    }}
                  >
                    <IoCloseOutline size="1.5rem" />
                  </button>
                )}
              </div>
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleFiltro();
                }}
                className={
                  isMobile
                    ? 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.95vh] tw-w-[4rem] tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                    : 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.95vh] 2xl:tw-w-[2.2vw] xl:tw-w-[3vw] tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                }
              >
                <LupaIcon w="1.5rem" h="1.5rem" />
              </button>
            </form>
          </div>
        </div>
        {!isMobile && (
          <>
            {!loading ? (
              <>
                <table className="tw-w-[100%] tw-border-separate [border-spacing:0_0.75rem] tw-table-auto">
                  <thead>
                    <tr className="tw-text-left xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                      <th className="tw-pl-[2.7rem]">Nome da Equipe</th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br />
                        recebidos
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br /> atendidos
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br /> não atendidos
                      </th>
                      <th className="tw-flex tw-items-center tw-gap-1 xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Taxa <br /> de sucesso{' '}
                        <Tooltip
                          label={
                            <span>
                              <span className="tw-font-bold">
                                Taxa de sucesso <br />{' '}
                              </span>
                              <span>
                                Leads finalizados com <br />
                                sucesso / leads totais recebidos
                              </span>
                            </span>
                          }
                          placement="bottom"
                          hasArrow
                        >
                          <a>
                            <AiOutlineInfoCircle
                              size="1.3rem"
                              color="#5A5A5A"
                            />
                          </a>
                        </Tooltip>
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads hot
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Produto
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Ação
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {slice.length > 0 &&
                      slice.map((el: any, index: any) => {
                        return (
                          <tr
                            key={index}
                            className={`${
                              +index % 2 > 0
                                ? 'tw-bg-[#F4F4F4]'
                                : 'tw-bg-[#E9EEF6]'
                            } tw-rounded-2xl tw-h-[6vh] `}
                          >
                            <td className="tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[2.4rem] ">
                              {el.nome}
                            </td>
                            <td>{el.leads_recebidos}</td>
                            <td>{el.leads_atendidos}</td>
                            <td>{el.nao_atendidos}</td>
                            <td>{el.taxa_sucesso}</td>
                            <td>{el.leads_hot}</td>
                            <td className="tw-text-[#E9EEF6]">
                              <span
                                className={`tw-rounded-[0.4rem] tw-px-[1vh] tw-py-[0.5vh] tw-bg-[#001E64]`}
                              >
                                {formatProduct(el.tipo_produto)}
                              </span>
                            </td>
                            <td>
                              <span className="tw-flex tw-justify-start">
                                <Tooltip
                                  label="Deletar equipe"
                                  placement="top"
                                  hasArrow
                                >
                                  <button
                                    onClick={() => {
                                      setExcluir(el);
                                      setOpenModalExcluir(true);
                                    }}
                                  >
                                    <BiTrash size="1.5rem" color="#AA2C23" />
                                  </button>
                                </Tooltip>
                                <Tooltip
                                  label="Alterar equipe"
                                  placement="top"
                                  hasArrow
                                >
                                  <Link
                                    to={
                                      '/corretor/leads/equipes/alterar-equipe'
                                    }
                                    state={{ equipe: el }}
                                  >
                                    <RiPencilLine size="1.5rem" />
                                  </Link>
                                </Tooltip>
                              </span>
                            </td>
                            <td
                              onClick={() => {
                                setAlterar(el);
                                setOpenModalInativar(true);
                              }}
                              className="tw-text-[#E9EEF6] tw-cursor-pointer"
                            >
                              <span
                                className={`tw-px-[1vh] tw-py-[0.5vh] tw-rounded-[0.4rem_0_0_0.4rem] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] ${
                                  el.status === 'inactive'
                                    ? 'tw-bg-[#323232]'
                                    : 'tw-bg-[#AAAAAA]'
                                }`}
                              >
                                Inativo
                              </span>

                              <span
                                className={`tw-px-[1vh] tw-py-[0.5vh] tw-rounded-[0_0.4rem_0.4rem_0] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] ${
                                  el.status === 'active'
                                    ? 'tw-bg-[#146EFA]'
                                    : 'tw-bg-[#AAAAAA]'
                                }`}
                              >
                                Ativo
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {originalData.length === 0 && (
                  <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
                    <svg
                      width="75"
                      height="75"
                      viewBox="0 0 75 75"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                        fill="#D2D2D2"
                      />
                    </svg>
                    <p className="tw-mt-2 tw-text-[#828282]">
                      Parece que você não tem nenhuma equipe registrada.{' '}
                    </p>
                  </div>
                )}
                {notFound === true && (
                  <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
                    <svg
                      width="75"
                      height="75"
                      viewBox="0 0 75 75"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                        fill="#D2D2D2"
                      />
                    </svg>
                    <p className="tw-mt-2 tw-text-[#828282]">
                      Sua pesquisa não encontrou nenhum nome de vendedor
                      correspondente.{' '}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <div className="tw-flex tw-justify-center">
                <Spinner />
              </div>
            )}
          </>
        )}
      </div>
      {isMobile && (
        <div className="tw-text-[0.9rem] tw-text-[#001E64]">
          {slice.length > 0 &&
            slice.map((el: any, index: any) => {
              if (slice.length < 1) {
                return (
                  <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
                    <svg
                      width="75"
                      height="75"
                      viewBox="0 0 75 75"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                        fill="#D2D2D2"
                      />
                    </svg>
                    <p className="tw-mt-2 tw-text-[#828282]">
                      Parece que você não tem nenhuma equipe registrada.{' '}
                    </p>
                  </div>
                );
              }
              return (
                <div
                  key={index}
                  className={`${
                    +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                  } tw-rounded-2xl tw-border-l-[0.3rem] tw-flex tw-flex-col tw-mt-2 tw-gap-1 tw-p-4 tw-border-solid tw-border-[#FF5000]`}
                >
                  <div className="">Nome da equipe - {el.nome}</div>
                  <div>
                    Leads recebidos -{' '}
                    <span className="tw-font-bold">{el.leads_recebidos}</span>
                  </div>
                  <div>
                    Leads atendidos -{' '}
                    <span className="tw-font-bold">{el.leads_atendidos}</span>
                  </div>
                  <div>
                    Leads não atendidos -{' '}
                    <span className="tw-font-bold">{el.nao_atendidos}</span>
                  </div>
                  <div>
                    Taxa de sucesso -{' '}
                    <span className="tw-font-bold">{el.taxa_sucesso}</span>
                  </div>
                  <div>
                    Leads hot -{' '}
                    <span className="tw-font-bold">{el.leads_hot}</span>
                  </div>
                  <div>
                    Produto{' '}
                    <span
                      className={`tw-rounded-[0.4rem] tw-px-[1vh] tw-py-[0.5vh] tw-text-white tw-bg-[#001E64]`}
                    >
                      {formatProduct(el.tipo_produto)}
                    </span>
                  </div>
                  <div
                    onClick={() => {
                      setOpenModalInativar(true);
                      setAlterar(el);
                    }}
                    className="tw-cursor-pointer tw-mt-2"
                  >
                    Status -{' '}
                    <span
                      className={`tw-px-[1vh] tw-py-[0.5vh]  tw-text-[#E9EEF6] tw-rounded-[0.4rem_0_0_0.4rem] ${
                        el.status === 'inactive'
                          ? 'tw-bg-[#323232]'
                          : 'tw-bg-[#AAAAAA]'
                      }`}
                    >
                      Inativo
                    </span>
                    <span
                      className={`tw-px-[1vh] tw-py-[0.5vh] tw-text-[#E9EEF6] tw-rounded-[0_0.4rem_0.4rem_0] ${
                        el.status === 'active'
                          ? 'tw-bg-[#146EFA]'
                          : 'tw-bg-[#AAAAAA]'
                      }`}
                    >
                      Ativo
                    </span>
                  </div>
                  <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-1">
                    <Link
                      className="tw-font-bold tw-border-[0.1rem] tw-px-4 tw-h-[2.5rem] tw-gap-1 tw-items-center tw-justify-center tw-flex  tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
                      to={'/corretor/leads/equipes/alterar-equipe'}
                      state={{ vendedor: el, perfis: '' }}
                    >
                      <RiPencilLine size="1.5rem" />
                      <span>Alterar equipe</span>
                    </Link>

                    <button
                      onClick={() => {
                        setOpenModalExcluir(true);
                        setExcluir(el);
                      }}
                      className="tw-font-bold tw-border-[0.1rem] tw-px-4 tw-h-[2.5rem] tw-gap-1 tw-items-center tw-justify-center tw-flex tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
                    >
                      <BiTrash size="1.5rem" color="#AA2C23" />{' '}
                      <span>Excluir equipe</span>
                    </button>
                  </div>
                </div>
              );
            })}
          {notFound === true && equipesData?.length === 0 && (
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Sua pesquisa não encontrou nenhuma equipe correspondente.{' '}
              </p>
            </div>
          )}
          {originalData.length <= 0 && (
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Parece que você não tem nenhuma equipe registrada.{' '}
              </p>
            </div>
          )}
        </div>
      )}
      <div className="tw-flex tw-justify-end tw-w-[100%]">
        <PaginateDot
          currentPage={page}
          lastPage={range}
          maxLength={5}
          setCurrentPage={setPage}
          totalData={equipesData}
        />
      </div>
      <div>
        <Dialog
          isOpen={openModalExcluir}
          setIsOpen={setOpenModalExcluir}
          title={'Excluir Equipe'}
          description={''}
        >
          <div className="tw-w-[100%] tw-flex tw-flex-col tw-items-center">
            <div>
              <div className="tw-text-center">
                <p>
                  Você deseja excluir a equipe ({excluir.nome})?
                  <br />
                  Ao excluir, os leads que estão com o status
                  <br />{' '}
                  <span className="tw-font-bold">
                    &quot;Novas oportunidades&quot;
                  </span>{' '}
                  voltarão para <br />
                  distribuição e você não conseguirá <br /> selecioná-lo. Os
                  leads que estiverem em <br />
                  tratativa permanecerão com o respectivo <br /> vendedor até a
                  conclusão
                </p>
              </div>
            </div>
            <div className="tw-flex tw-items-between tw-justify-between tw-w-[100%] tw-mt-6">
              <button
                onClick={() => {
                  setOpenModalExcluir(false);
                }}
                className="tw-font-bold tw-border-[0.1rem] tw-w-[9rem] tw-py-[0.5rem] tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  handleDeleteEquipe();
                }}
                disabled={loading}
                className="tw-font-bold  tw-w-[9rem] tw-py-[0.5rem] tw-rounded-full tw-bg-[#FF5000] tw-text-[#FFFF]"
              >
                Sim
              </button>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={openModalInativar}
          setIsOpen={setOpenModalInativar}
          title={
            alterar.status === 'inactive' ? 'Ativar Equipe' : 'Inativar Equipe'
          }
          description={''}
        >
          <div className="tw-w-[100%] tw-flex tw-flex-col tw-items-center">
            <div>
              <div className="tw-text-center">
                <p>
                  Você deseja{' '}
                  {alterar.status === 'inactive' ? 'ativar' : 'inativar'} a
                  equipe ({alterar.nome})?
                  <br />
                  {alterar.status === 'active' && (
                    <>
                      Ao inativar, a equipe não ficará
                      <br /> mais disponível para distribuir leads
                    </>
                  )}
                </p>
              </div>
            </div>
            <div className="tw-flex tw-items-between tw-justify-between tw-w-[100%] tw-mt-6">
              <button
                onClick={() => {
                  setOpenModalInativar(false);
                }}
                className="tw-font-bold tw-border-[0.1rem] tw-w-[9rem] tw-py-[0.5rem] tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  handleAlterarStatusUsuario();
                }}
                className="tw-font-bold  tw-w-[9rem] tw-py-[0.5rem] tw-rounded-full tw-bg-[#FF5000] tw-text-[#FFFF]"
              >
                Sim
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};
